// 8 quiz questions based on the Trainer Portal onboarding video

const quizData = [
  {
    id: 1,
    question: "What is included in the first class of the course?",
    options: [
      "Only trainer introduction",
      "Practical lab session",
      "Complete curriculum overview and roadmap",
      "Final test",
    ],
    correctAnswer: 2,
  },
  {
    id: 2,
    question:
      "What is the purpose of starting sessions with fundamentals and recap?",
    options: [
      "To reduce session time",
      "To ensure better understanding and continuity",
      "To skip advanced topics",
      "To test students",
    ],
    correctAnswer: 1,
  },
  {
    id: 3,
    question:
      "Which tools are used to improve clarity and engagement during sessions?",
    options: [
      "Only PPTs",
      "Digital whiteboards and screen sharing",
      "WhatsApp chats",
      "Email communication",
    ],
    correctAnswer: 1,
  },
  {
    id: 4,
    question: "What is the policy regarding AI tools during live classes?",
    options: [
      "Fully allowed",
      "Allowed only for trainers",
      "Not used to ensure authentic learning",
      "Used for assignments only",
    ],
    correctAnswer: 2,
  },
  {
    id: 5,
    question:
      "What should trainers do regarding their personal contact details?",
    options: [
      "Share with all students",
      "Share only with top performers",
      "Do not share with students",
      "Share after course completion",
    ],
    correctAnswer: 2,
  },
  {
    id: 6,
    question: "How should planned leaves be managed by trainers?",
    options: [
      "Inform students directly",
      "Inform admin/HR in advance and take approval",
      "Take leave without informing",
      "Cancel classes anytime",
    ],
    correctAnswer: 1,
  },
  {
    id: 7,
    question: "What should a trainer do if a student does not join the session?",
    options: [
      "Cancel immediately",
      "Wait for 5 minutes",
      "Wait up to 15 minutes",
      "End the class early",
    ],
    correctAnswer: 2,
  },
  {
    id: 8,
    question: "Where should trainers upload study materials?",
    options: [
      "WhatsApp",
      "Personal drive",
      "Trainer portal",
      "Email only",
    ],
    correctAnswer: 2,
  },
];

export default quizData;
